(function () {
  'use strict';

  // Sideways scrolling for the product media gallery on desktop.
  //
  // main-product-gallery.js builds the gallery with Splide but leaves it with
  // click, drag and (when enabled) arrows only, so a two-finger sideways swipe
  // over the images does nothing on a trackpad or a Magic Mouse. This walks the
  // gallery the pointer sits over, one image per flick.
  //
  // Only horizontal intent is consumed - a sideways wheel delta, or shift with
  // a plain wheel, which is how a one-axis mouse scrolls sideways. Vertical
  // wheel events are left alone so the page still scrolls under the cursor.
  // preventDefault on the ones we do act on also stops Safari and Chrome
  // reading the same gesture as a swipe back through history.

  var DESKTOP = '(min-width: 989px)'; // the breakpoint main-product-gallery.js uses
  var STEP = 30; // px of sideways travel that advances one image
  var GESTURE_END = 200; // ms of quiet that ends a flick
  var COOLDOWN = 400; // ms - Splide's default transition, so one flick is one image

  // A wheel reports lines or pages on some mice; normalise to roughly pixels.
  var UNIT = { 0: 1, 1: 16, 2: 100 };

  var travel = 0;
  var lastEvent = -Infinity;
  var lastMove = -Infinity;

  function horizontalDelta(e) {
    var scale = UNIT[e.deltaMode] || 1;
    if (e.deltaX) return e.deltaX * scale;
    if (e.shiftKey) return e.deltaY * scale;
    return 0;
  }

  function galleryUnder(target) {
    var gallery = target && target.closest && target.closest('main-product-gallery');
    if (!gallery) return null;
    // The main slider is synced to the thumbnails, so moving it scrolls the
    // strip too. Layouts without a main slider fall back to the thumbnails.
    return gallery.mainSlider || gallery.thumbnailSlider || null;
  }

  document.addEventListener(
    'wheel',
    function (e) {
      if (!window.matchMedia(DESKTOP).matches) return;

      var delta = horizontalDelta(e);
      if (!delta) return;

      var slider = galleryUnder(e.target);
      if (!slider) return;

      e.preventDefault();

      var now = e.timeStamp;
      if (now - lastEvent > GESTURE_END) travel = 0;
      lastEvent = now;

      // A trackpad emits a long tail of small deltas after the fingers lift;
      // ignoring them while the slide animates keeps one flick to one image.
      if (now - lastMove < COOLDOWN) return;

      travel += delta;
      if (Math.abs(travel) < STEP) return;

      slider.go(travel > 0 ? '>' : '<');
      travel = 0;
      lastMove = now;
    },
    { passive: false }
  );
})();
